import { useFocusEffect } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import { ModalManager } from '../Components/Web/Modal/hooks/useModalManager';
import useSession from '../Hooks/useSession';
import Account, {
  AddPayment,
  ChoosePlan,
  GetHelp,
  GiftCard,
  Legal,
  LegalBindingContract,
  Notification,
  PaymentMethod,
  Profile,
  ReferAndEarn,
} from '../Screens/Account';
import { AddEditAddress, AddressMap, SavedAddresses } from '../Screens/Address';
import Cart from '../Screens/Cart';
import SignupVerificationSuccess from '../Screens/DeepLinkingLanding/SignupVerificationSuccess';
import OrderDetails from '../Screens/OrderDetails';
import OrderTracking from '../Screens/OrderTracking';
import Product from '../Screens/Product';
import ProductSpecialInstruction from '../Screens/Product/SpecialInstruction';
import ReservationEventDetails from '../Screens/ReservationEventDetails';
import Search from '../Screens/Search';
import StoreInformation from '../Screens/StoreInformation';
import { FullReviewList } from '../Screens/StoreReviews';

import DrawerNavigator from './DrawerNavigator';
import routeList from './list';
import RootNavigatorBase from './RootNavigatorBase';

const Stack = createStackNavigator();

const useBackButton = () => {
  const handleEvent = () => {
    ModalManager.hideAll();
  };

  useFocusEffect(() => {
    if (window.location.pathname.slice(1) !== routeList.CHECKOUT) {
      window.history.pushState(
        null,
        '',
        window.location.pathname + window.location.search,
      );
    }

    window.addEventListener('popstate', handleEvent);
    return () => window.removeEventListener('popstate', handleEvent);
  });

  return;
};

function restrictedRoute() {
  return (
    <>
      <Stack.Screen name={routeList.HOME} component={DrawerNavigator} />
      {/* App Navigator*/}
      <Stack.Screen name={routeList.SEARCH} component={Search} />
      <Stack.Screen
        name={routeList.STORE_INFORMATION}
        component={StoreInformation}
      />
      <Stack.Screen name={routeList.PRODUCT} component={Product} />
      <Stack.Screen
        name={routeList.PRODUCT_SPECIAL_INSTRUCTION}
        component={ProductSpecialInstruction}
      />
      <Stack.Screen name={routeList.CART} component={Cart} />
      <Stack.Screen name={routeList.ORDER_TRACKING} component={OrderTracking} />
      <Stack.Screen name={routeList.ORDER_RATING} component={OrderDetails} />
      <Stack.Screen name={routeList.ORDER_DETAILS} component={OrderDetails} />
      <Stack.Screen name={routeList.STORE_REVIEWS} component={FullReviewList} />

      <Stack.Group screenOptions={{ presentation: 'modal' }}>
        <Stack.Screen
          name={routeList.ADDRESS_SELECTOR}
          component={SavedAddresses}
        />
        <Stack.Screen
          name={routeList.ADDRESS_ADD_EDIT}
          component={AddEditAddress}
        />
        <Stack.Screen name={routeList.ADDRESS_MAP} component={AddressMap} />
      </Stack.Group>

      {/* Profile Screen */}
      <Stack.Screen name={routeList.ACCOUNT} component={Account} />
      <Stack.Screen name={routeList.PROFILE} component={Profile} />
      <Stack.Screen name={routeList.PAYMENT_METHOD} component={PaymentMethod} />
      <Stack.Screen name={routeList.ADD_PAYMENT} component={AddPayment} />
      <Stack.Screen name={routeList.NOTIFICATION} component={Notification} />
      <Stack.Screen name={routeList.GIFT_CARD} component={GiftCard} />
      <Stack.Screen name={routeList.REFER_AND_EARN} component={ReferAndEarn} />
      <Stack.Screen name={routeList.CHOOSE_PLAN} component={ChoosePlan} />
      <Stack.Screen name={routeList.GET_HELP} component={GetHelp} />
    </>
  );
}

function AuthNavigator() {
  useBackButton();
  useSession(); // to run the session renewal

  return (
    <RootNavigatorBase>
      <Stack.Navigator screenOptions={{ headerShown: false }}>
        {restrictedRoute()}
        <Stack.Screen name={routeList.LEGAL} component={Legal} />
        <Stack.Screen
          name={routeList.LEGAL_BINDING_CONTRACT}
          component={LegalBindingContract}
        />
        <Stack.Screen
          name={routeList.RES_EVENT_DETAILS_PREVIEW}
          component={ReservationEventDetails}
        />
        {/* For deep linking that can access even user is logged in */}
        <Stack.Screen
          name={routeList.SIGNUP_VERIFICATION_SUCCESS}
          component={SignupVerificationSuccess}
        />
      </Stack.Navigator>
    </RootNavigatorBase>
  );
}

export default AuthNavigator;
